import {
  callApiDownloadExportBaoCao,
  callApiLayDanhSachBaoCaoTable,
  callApiBaoCaoVanBanDi,
  callApiDownloadExportBaoCaoVanBanDi,
  callApiDownloadExportThongKeBaoCaoVbd,
} from "@/api/bao-cao";

const layDanhSachBaoCaoTable = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachBaoCaoTable(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_BAO_CAO_TABLE", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layBaoCaoVanBanDi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiBaoCaoVanBanDi(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "LAY_DANH_SACH_BAO_CAO_VAN_BAN_DI_TABLE",
            response.data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const downloadExportBaoCao = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDownloadExportBaoCao(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const downloadExportBaoCaoThongKeVbd = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDownloadExportThongKeBaoCaoVbd(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const downloadExportBaoCaoVanBanDi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDownloadExportBaoCaoVanBanDi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  downloadExportBaoCaoThongKeVbd,
  layDanhSachBaoCaoTable,
  downloadExportBaoCao,
  layBaoCaoVanBanDi,
  downloadExportBaoCaoVanBanDi,
};
